<script setup lang="ts"> 
const emit = defineEmits(['init'])
onMounted(() => {
    emit('init')
})
const dev = computed<boolean>(() => isDev())
</script>
<template>
    <div v-if="dev" class="flex justify-center flex-col items-center h-full w-full text-lg font-medium py-12">
        <img src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbW03czF1Y3lhMGJ0bzdsdnl3ZHQ5YXhqenI0ZTRrdWhwbG43eG5haiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3ohzdQ1IynzclJldUQ/giphy.gif" alt="confused_emilio">
    </div>
    <div v-else>
        Caricamento...
    </div>
</template>